export class Role {
    public id: string;
    public name: string;
    public label: string;
}



// WEBPACK FOOTER //
// ./src/lemsar/auth/domains/models/role.ts